import React, { useEffect, useReducer } from 'react';
import { thumbnailSource, subscribeThumbnail, refreshThumbnail, rejectThumbnail, rememberPropertyPhoto } from '../services/propertyThumbnails';

export default function PropertyThumbnail({ listingKey, src, alt, className, style, loading = 'lazy', decoding = 'async' }) {
  const [, update] = useReducer(value => value + 1, 0);
  // Non-listing images can still fail gracefully without requesting MLS media.
  const cacheKey = listingKey || `image:${src || alt}`;
  const source = thumbnailSource(cacheKey, src);
  useEffect(() => {
    const unsubscribe = subscribeThumbnail(cacheKey, update);
    if (!thumbnailSource(cacheKey, src) && listingKey) refreshThumbnail(listingKey);
    return unsubscribe;
  }, [cacheKey, listingKey, src]);
  return source ? <img src={source} alt={alt} className={className} style={style} loading={loading} decoding={decoding}
    onLoad={() => rememberPropertyPhoto(cacheKey, source)}
    onError={() => rejectThumbnail(cacheKey, source, Boolean(listingKey))} /> :
    <span className={`${className || ''} assistant-property-placeholder`} style={style} role="img" aria-label={`${alt || 'Property'} — photo unavailable`}><i aria-hidden="true">🏠</i><small>Photo unavailable</small></span>;
}
